<app-grid>
    <app-cell mobile="0:12"
              tablet="0:8"
              laptop="0:4"
              desktop="0:4"
    >
        <div class="forgot-password">
            <app-button theme="link"
                        icon="chevron-left"
                        layout="icon-label"
                        (click)="goToLogin()"
            >
                {{ 'auth.back-to-login' | translate }}
            </app-button>

            <div class="forgot-password__text">
                <h1>
                    {{ 'auth.forgot-password' | translate }}
                </h1>

                <label class="dark-grey">
                    {{ 'auth.enter-mail' | translate }}
                </label>
            </div>

            <app-input [placeholder]="'contact.enter-email' | translate"
                       [control]="email"
                       [errorMessages]="emailErrorMessages"
            >
                {{ 'register.email' | translate }}
            </app-input>

            <app-button layout="label-only"
                        [disabled]="email.invalid"
                        (click)="submit()"
                        class="forgot-password__button"
            >
                {{ 'common.submit' | translate }}
            </app-button>
        </div>
    </app-cell>
</app-grid>
